/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-model',
    'pip-events',
    'window'
],
function(
    pip,
    pipEvents,
    window
){
	function initEventListeners(){
        pipEvents.cards.cardClicked.off();
        pipEvents.cards.cardClicked.on(function(event, cardTitle) {

        var obj = {
          eventInfo: {
            eventName: 'pip sub-content'
          },
          category: {
            primaryCategory: 'interaction'
          },
          subContent: {
            section: 'product card',
            component: cardTitle,
            target: 'n/a'
          },
        };
        if(window.digitalData && window.digitalData.event) window.digitalData.event.push(obj);
    })
	}
	return {
		init: function init(){
			initEventListeners();
		}
	}
});

}.call(window));